import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getUrlParam } from 'common/util/url/urlUtil';
import { isViewAsStudent } from 'common/util/shared/sharedUtils';
import { refreshMissingProperties } from 'common/store/context/actions';
import { userIsStudent } from '../../../services/permissions/PermissionService';
import { ContextState } from '../../../store/context/reducer';
import AiMarkingEmbedWrapper from './AiMarkingEmbedWrapper';
import AiMarkingViewHeader from './AiMarkingViewHeader';
import * as styles from './AiMarkingFullWindow.scss';

/** Tab opened from the candidate report: one question's Graide marking, read-only. */
const AiMarkingFullWindow: React.FC = () => {
    const context = {
        assessmentRunId: Number(getUrlParam('assessmentRunId')),
        partyId: Number(getUrlParam('partyId')),
        questionId: Number(getUrlParam('questionId')),
    } as ContextState;
    const dispatch = useDispatch();

    // No FeatureLoader mounts in this tab, so request the question state it would have loaded.
    React.useEffect(() => {
        dispatch(refreshMissingProperties(context.questionId, ['questionState']));
    }, [dispatch, context.questionId]);

    return (
        <div className={styles.fullWindow}>
            <AiMarkingViewHeader />
            <AiMarkingEmbedWrapper context={context} forceReadOnly isCandidate={userIsStudent() || isViewAsStudent()} />
        </div>
    );
};

export default AiMarkingFullWindow;
